// Contact page (item 11) — reveals a note pointing to the dedicated
// bespoke enquiry form when "Bespoke" is chosen in the topic select.
// Self-contained: no shared drawer/modal utility touched.
(function () {
  var root = document.querySelector('[data-wn-contact]');
  if (!root) return;

  var select = root.querySelector('[data-wn-contact-topic]');
  var note = root.querySelector('[data-wn-contact-bespoke-note]');
  if (!select || !note) return;

  function sync() {
    var opt = select.options[select.selectedIndex];
    var isBespoke = !!(opt && opt.dataset && opt.dataset.bespoke === 'true');
    note.hidden = !isBespoke;
  }

  select.addEventListener('change', sync);
  sync();
})();
